import {Alert, Card, CardBody, Col, Media, Row, Spinner, UncontrolledTooltip} from 'reactstrap';
import {PERMISSION_ACTIONS, PERMISSION_SUBJECTS} from '../Permissions/permissionsUtils';
import {useNMutation, useNQuery} from '../../../services/decorators/apolloGraphQL';
import {DEFAULT_GRAPHQL_POLL_INTERVAL} from '../../../services/configs/constants';
import PerfectScrollbar from 'react-perfect-scrollbar';
import React, {useEffect, useState} from 'react';
import UseAction from '../useAction';
import {gql} from '@apollo/client';
import UseIcon from '../useIcon';
import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

const Tokens = (props = {}) => {
    //Consts&states
    const {handleChangeTokenStatus, handleShowToken} = props;
    const [error, setError] = useState(null);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [redirectTo, setRedirectTo] = useState('');

    //queries&mutations
    const GET_ITEMS = {
        query: gql`
            query{
                responseQuery: obtenerTokensDictaminador(
                    filtros:{estatus: PENDIENTE}
                ){
                    id
                    token
                    createdAt
                    accion{
                        titulo
                    }
                    solicitante{
                        nombres
                        apellidos
                    }
                }
            }
        `
    };
    const APPROVE_ITEM = {
        mutation: gql`
            mutation approveItem($input:AprobarTokenAutorizacionInput!){
                responseMutation: aprobarTokenAutorizacion(input:$input){
                    ok
                    error
                }
            }
        `
    };
    const REJECT_ITEM = {
        mutation: gql`
            mutation rejectItem($input:RechazarTokenAutorizacionInput!){
                responseMutation: rechazarTokenAutorizacion(input:$input){
                    ok
                    error
                }
            }
        `
    };

    //useQueries&useMutations
    const {runMutation: approveItem} = useNMutation(APPROVE_ITEM);
    const {runMutation: rejectItem} = useNMutation(REJECT_ITEM);
    const {
        runQuery: executeQuery,
        data: dataTokens,
        loading: loadingTokens,
        error: errorTokens,
    } = useNQuery(GET_ITEMS, {pollInterval: DEFAULT_GRAPHQL_POLL_INTERVAL});

    //effects
    useEffect(() => {
        executeQuery().then();
    }, []);

    useEffect(() => {
        if (!loadingTokens && !errorTokens && dataTokens?.responseQuery) {
            setLoading(false);
            setError(false);
            setItems(arrangeItems(dataTokens.responseQuery));
        } else if (errorTokens) {
            setLoading(false);
            setError(true);
        } else if (loadingTokens) {
            setLoading(true);
            setError(false);
        }
    }, [dataTokens, loadingTokens, errorTokens]);


    //arrangeData
    const arrangeItems = (dataItems) => {
        const response = [];
        if (dataItems && dataItems.length > 0) {
            dataItems.forEach((dataItem) => {
                let timeAgo = '';
                const {accion, solicitante} = dataItem;
                const usuario = `Solicitante: ${solicitante?.nombres || ''} ${solicitante?.apellidos || ''}`;

                if (dataItem.createdAt) timeAgo = moment(dataItem.createdAt).fromNow();
                let userTruncated = usuario?.length > 35 ? `${usuario.substring(0, 35)}...` : usuario;
                let titleTruncated = accion?.titulo?.length > 25 ? `${accion.titulo.substring(0, 25)}...` : accion.titulo;

                response.push({
                    ...dataItem,
                    titleTruncated: titleTruncated,
                    userTruncated: userTruncated,
                    timeAgo: timeAgo,
                });
            });
        }
        return response;
    }

    //handleFunctions
    const handleItem = async (props = {}) => {
        const {e, item = {}} = props;
        e.preventDefault();
        e.stopPropagation();
        if (item.id) {
            handleShowToken({id: item.id, titulo: 'Token de autorización'});
        }
    }

    const handleApprove = (props = {}) => {
        const {e, item = {}} = props;
        e.preventDefault();
        e.stopPropagation();
        if (item.id) {
            const id = item.id;
            const title = 'Aprobar token de autorización';
            const text = `Se aprobará la acción ${item.accion.titulo} solicitada por el usuario ${item.solicitante.nombres} ${item.solicitante.apellidos}, ¿deseas continuar?`;
            const mutation = async () => {
                try {
                    await approveItem({variables: {input: {token: item.token}}});
                } catch (err) {
                    console.log(err);
                }
            };
            handleChangeTokenStatus({id, title, text, mutation});
        }
    }

    const handleReject = (props = {}) => {
        const {e, item = {}} = props;
        e.preventDefault();
        e.stopPropagation();
        if (item.id) {
            const id = item.id;
            const title = 'Rechazar token de autorización';
            const text = `Se rechazará la acción ${item.accion.titulo} solicitada por el usuario ${item.solicitante.nombres} ${item.solicitante.apellidos}, ¿deseas continuar?`;
            const mutation = async () => {
                try {
                    await rejectItem({variables: {input: {token: item.token, motivoRechazo: ''}}});
                } catch (err) {
                    console.log(err);
                }
            };
            handleChangeTokenStatus({id, title, text, mutation});
        }
    }

    const handleViewAll = () => {
        setRedirectTo('/authorizationTokens');
    }

    //renderFunctions
    const _renderActions = (item) => {
        return (
            <div className='d-flex justify-content-around' style={{marginTop: '7px'}}>
                <UseAction
                    canData={{
                        subject: PERMISSION_SUBJECTS.authorizationTokens.name,
                        action: PERMISSION_ACTIONS.update.name,
                    }}
                    render={(
                        <a className='my-0' id={`approve-${item.id}`} style={{color: '#28a745'}}
                           onClick={(e) => {handleApprove({e, item})}}
                        >
                            <UseIcon name='checkCircle' key={`approve-${item.id}`} size={20}/>
                            <UncontrolledTooltip placement='top' target={`approve-${item.id}`}>Aprobar</UncontrolledTooltip>
                        </a>
                    )}
                />
                <UseAction
                    canData={{
                        subject: PERMISSION_SUBJECTS.authorizationTokens.name,
                        action: PERMISSION_ACTIONS.update.name,
                    }}
                    render={(
                        <a className='my-0' id={`reject-${item.id}`} style={{color: '#dc3545'}}
                           onClick={(e) => {handleReject({e, item})}}
                        >
                            <UseIcon name='xCircle' key={`reject-${item.id}`} size={20}/>
                            <UncontrolledTooltip placement='top' target={`reject-${item.id}`}>Rechazar</UncontrolledTooltip>
                        </a>
                    )}
                />
            </div>
        )
    }

    //renders
    if (redirectTo) {
        window.location.href = redirectTo;
    }

    return (
        <Row>
            {(loading) ? (
                <Col className='text-center my-4'>
                    <Spinner color='primary' size='lg'/>
                </Col>
            ) : (error) ? (
                <Card>
                    <CardBody style={{lineHeight: 'initial'}}>
                        <Alert color='danger'>
                            <div className='alert-heading'>Error</div>
                            Lo sentimos, hubo un problema al intentar obtener la información de esta sección, favor de
                            intentarlo más tarde o ponerse en contacto con el proveedor del sistema.
                        </Alert>
                    </CardBody>
                </Card>
            ) : (
                <>
                    <Col sm='12' className='my-1'>
                        <div className='d-flex justify-content-center'>
                            <span className='text-primary cursor-pointer ml-1' onClick={handleViewAll}>Ver Todos</span>
                        </div>
                    </Col>
                    {items?.length > 0 ? (
                        <Col sm='12'>
                            <PerfectScrollbar
                                className='media-list overflow-hidden position-relative'
                                options={{wheelPropagation: false}}
                            >
                                {items?.map((item) => (
                                    <div className='d-flex justify-content-between'
                                         onClick={(e) => {handleItem({e, item}).then()}}>
                                        <Media className='d-flex align-items-start'>
                                            <Media body>
                                                <Media heading className='primary media-heading' tag='h6'>
                                                    {item.titleTruncated}
                                                </Media>
                                                <p className='notification-text'>
                                                    {item.userTruncated}
                                                </p>
                                            </Media>
                                            <div>
                                                <small>
                                                    <time className='media-meta' dateTime={item.createdAt}>
                                                        {item.timeAgo}
                                                    </time>
                                                </small>
                                                {_renderActions(item)}
                                            </div>
                                        </Media>
                                    </div>
                                ))}
                            </PerfectScrollbar>
                        </Col>
                    ) : (
                        <Col className='text-center my-4'>
                            <UseIcon name='checkCircle' adjust='text-muted' size={20}/>
                            <span className='ml-1 text-muted'>Sin Tokens Pendientes</span>
                        </Col>
                    )}
                </>
            )}
        </Row>
    );
};

export default Tokens;